"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapElementsJson = exports.forEachElementJson = exports.forEachElement = exports.flattenElementsJson = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isMultipleElementJson = function isMultipleElementJson(el) {
  return !el.id;
};

var isMultipleElement = function isMultipleElement(el) {
  return !el.id;
};

var forEachElement = function forEachElement() {
  var elementsCollection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fn = arguments.length > 1 ? arguments[1] : undefined;
  elementsCollection.forEach(function (el) {
    if (isMultipleElement(el)) {
      if (el.get('entities') && el.get('entities').length > 0) {
        return forEachElement(el.get('entities'), fn);
      } else if (el.get('elements')) {
        return forEachElement(el.get('elements'), fn);
      }
    } else {
      return fn(el);
    }
  });
};

exports.forEachElement = forEachElement;

var forEachElementJson = function forEachElementJson() {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fn = arguments.length > 1 ? arguments[1] : undefined;
  elements.forEach(function (el) {
    if (isMultipleElementJson(el)) {
      if (el.entities && el.entities.length > 0) {
        return forEachElementJson(el.entities, function (subEl) {
          subEl.parent = el.type;
          fn(subEl);
        });
      } else if (el.elements) {
        return forEachElementJson(el.elements, function (subEl) {
          subEl.parent = el.type;
          fn(subEl);
        });
      }
    } else {
      return fn(el);
    }
  });
};

exports.forEachElementJson = forEachElementJson;

var flattenElementsJson = function flattenElementsJson(elements) {
  var result = [];
  forEachElementJson(elements, function (el) {
    return result.push(el);
  });
  return result;
};

exports.flattenElementsJson = flattenElementsJson;

var mapElementsJson = function mapElementsJson(elements, fn) {
  return elements.map(function (el) {
    if (isMultipleElementJson(el)) {
      if (el.entities && el.entities.length > 0) {
        var entities = mapElementsJson(el.entities, fn);
        entities.map(function (e) {
          return e.parent = el.type;
        });
        return _objectSpread(_objectSpread({}, el), {}, {
          entities: entities
        });
      } else if (el.elements) {
        var subElements = mapElementsJson(el.elements, fn);
        subElements.map(function (e) {
          return e.parent = el.type;
        });
        return _objectSpread(_objectSpread({}, el), {}, {
          elements: subElements
        });
      }
    } else {
      return fn(el);
    }
  });
};

exports.mapElementsJson = mapElementsJson;